/** API route map: URLS.Controller.StateMinWageRate */
export const StateMinWageRate = {
      Name: 'StateMinWageRate/',
      GetAll: 'getall',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
